export function build_graph_of_watershed_connections(watershed, exits) {
    if (exits.length === 0)
        throw new Error(`Must provide at least one exit for building watershed connections graph`);
    const connections = get_empty_connections_map(watershed.watershed_count);
    // mutate_connections_with_exits(watershed, exits, connections)
    for (let x = 0; x < watershed.input_width; ++x) {
        for (let y = 0; y < watershed.input_height; ++y) {
            const vertex = watershed.vertices[x + y * watershed.input_width];
            if (vertex.watershed_ids.size === 1)
                continue;
            vertex.watershed_ids.forEach(watershed_id_1 => {
                vertex.watershed_ids.forEach(watershed_id_2 => {
                    var _a;
                    if (watershed_id_1 === watershed_id_2)
                        return;
                    const existing_boundary = (_a = connections.get(watershed_id_1)) === null || _a === void 0 ? void 0 : _a.get(watershed_id_2);
                    if (existing_boundary === undefined || existing_boundary.z > vertex.z) {
                        connections.get(watershed_id_1).set(watershed_id_2, { x, y, z: vertex.z, id: watershed_id_2 });
                    }
                });
            });
        }
    }
    return connections;
}
function get_empty_connections_map(watershed_count) {
    const connections = new Map();
    for (let watershed_id = 0; watershed_id < watershed_count; ++watershed_id) {
        connections.set(watershed_id, new Map());
    }
    return connections;
}
// function mutate_connections_with_exits(watershed: Watersheds, exits: Exit[], connections: Map<number, Map<number, (Vertex & Id)>>)
// {
//     exits.forEach(exit =>
//     {
//         const vertex = watershed.vertices[exit.x + exit.y * watershed.input_width]
//         vertex.watershed_ids.forEach(watershed_id =>
//         {
//             connections.get(watershed_id)!.set(exit.id, exit)
//         })
//     })
// }
